module.exports = new Promise(resolve => {
            const script = document.createElement('script');
            script.src = window.location.origin + '/mfe/population-health/remoteEntry.js';
            script.onload = () => { resolve(window['populationHealth']); };
            script.onerror = () => { resolve({ get: () => Promise.resolve(() => () => 'Module populationHealth unavailable'), init: () => {} }); };
            document.head.appendChild(script);
        });